"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _AppContainer = require("./AppContainer");
Object.keys(_AppContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AppContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AppContainer[key];
    }
  });
});